import { TextInput } from 'react-native';
import { Input } from '@ui-kitten/components';
export default {
    Native: TextInput,
    Kitten: Input,
};
//# sourceMappingURL=TextField.js.map